import { render, staticRenderFns } from "./Ellipsis.vue?vue&type=template&id=4b5c313c&scoped=true&shadow"
import script from "./Ellipsis.vue?vue&type=script&lang=js&shadow"
export * from "./Ellipsis.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./Ellipsis.vue?vue&type=style&index=0&id=4b5c313c&scoped=true&lang=css&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4b5c313c",
  null
  ,true
)

export default component.exports